import {XHRBackend, Http, RequestOptions} from "@angular/http";
import {HttpSecure} from "./httpSecure.service";
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";


export function HttpFactory(
    xhrBackend: XHRBackend,
    requestOptions: RequestOptions,
    authenticationService: AuthenticationService,
): Http {
    requestOptions.url = environment.url;
    requestOptions.headers.set("Accept", "application/json");
    requestOptions.headers.set("Content-Type", "application/json");
    return new HttpSecure(xhrBackend, requestOptions, authenticationService);
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/authentication/service/httpSecure.factory.ts